// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1WORp","search":"Settings_search__3Z8Oh","filter":"Settings_filter__20KiP"};